// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"Reports_maincontainer__3Igda","heading":"Reports_heading__3PkDQ","gridholder":"Reports_gridholder__1ssAN","gridcontainer":"Reports_gridcontainer__3F7b_"};